
import { DomainSubject } from "./domainSubject";

export class PageClientSubjectData {
    eventTime = new Date();
}

export class PageClientExecutionEndedSubject extends DomainSubject<PageClientSubjectData> {
    name = "PageClientExecutionEndedSubject";
    mustBeTriggeredOnce = true;


    onAfterTrigger = () => {
        setTimeout(() => {
            const endEvent = new CustomEvent<PageClientSubjectData>("adRunner_SlotRenderEnded");
            dispatchEvent(endEvent);
        }, 6000);
    }

    init = () => {
        this.subscribe(() => {
            const endEvent = new CustomEvent<PageClientSubjectData>("PageClientExecutionEnded");
            dispatchEvent(endEvent);
        })
    }

}

const pageClientExecutionEndedSubject = new PageClientExecutionEndedSubject();
pageClientExecutionEndedSubject.activate();

export { pageClientExecutionEndedSubject };